import type { RouteObject } from 'react-router';

import { Path } from '../../assets/enums';
import { lazyNamedPage, renderLazyPage } from './lazy-page';

const HomePage = lazyNamedPage(() => import('@pages/home/HomePage.tsx'), 'HomePage');
const ProfilePage = lazyNamedPage(() => import('@pages/profile/ProfilePage.tsx'), 'ProfilePage');
const PartnersPage = lazyNamedPage(() => import('@pages/partners/PartnersPage.tsx'), 'PartnersPage');
const PerformancePage = lazyNamedPage(
  () => import('@pages/performance/PerformancePage.tsx'),
  'PerformancePage'
);
const CoursesPage = lazyNamedPage(() => import('@pages/courses/CoursesPage.tsx'), 'CoursesPage');
const PlayersPage = lazyNamedPage(() => import('@pages/players/PlayersPage.tsx'), 'PlayersPage');
const PlayerPage = lazyNamedPage(() => import('@pages/player/PlayerPage.tsx'), 'PlayerPage');
const GameplayPage = lazyNamedPage(() => import('@pages/gameplay/GameplayPage.tsx'), 'GameplayPage');
const PartnerPage = lazyNamedPage(() => import('@pages/partner/PartnerPage.tsx'), 'PartnerPage');
const CoursePage = lazyNamedPage(() => import('@pages/course/CoursePage.tsx'), 'CoursePage');
const HolePage = lazyNamedPage(() => import('@pages/hole/HolePage.tsx'), 'HolePage');
const UsersPage = lazyNamedPage(() => import('@pages/users/UsersPage.tsx'), 'UsersPage');
const UserPage = lazyNamedPage(() => import('@pages/users/UserPage.tsx'), 'UserPage');
const DevicesPage = lazyNamedPage(() => import('@pages/devices/DevicesPage.tsx'), 'DevicesPage');
const DevicePage = lazyNamedPage(() => import('@pages/device/DevicePage.tsx'), 'DevicePage');
const EditPartnerPage = lazyNamedPage(
  () => import('@pages/partner/EditPartnerPage.tsx'),
  'EditPartnerPage'
);
const AddCoursePage = lazyNamedPage(() => import('@pages/add-course/AddCoursePage.tsx'), 'AddCoursePage');
const EditCoursePage = lazyNamedPage(
  () => import('@pages/course/EditCoursePage.tsx'),
  'EditCoursePage'
);

export const privateRoutes: RouteObject[] = [
  { path: Path.Home, element: renderLazyPage(<HomePage />) },
  { path: Path.Profile, element: renderLazyPage(<ProfilePage />) },
  { path: Path.Partners, element: renderLazyPage(<PartnersPage />) },
  { path: Path.Performance, element: renderLazyPage(<PerformancePage />) },
  { path: Path.Courses, element: renderLazyPage(<CoursesPage />) },
  { path: Path.Players, element: renderLazyPage(<PlayersPage />) },
  { path: Path.Player, element: renderLazyPage(<PlayerPage />) },
  { path: Path.Gameplay, element: renderLazyPage(<GameplayPage />) },
  { path: Path.Partner, element: renderLazyPage(<PartnerPage />) },
  { path: Path.Course, element: renderLazyPage(<CoursePage />) },
  { path: Path.Hole, element: renderLazyPage(<HolePage />) },
  { path: Path.Users, element: renderLazyPage(<UsersPage />) },
  { path: Path.User, element: renderLazyPage(<UserPage />) },
  { path: Path.Devices, element: renderLazyPage(<DevicesPage />) },
  { path: Path.Device, element: renderLazyPage(<DevicePage />) },
  { path: Path.AddPartner, element: renderLazyPage(<EditPartnerPage />) },
  { path: Path.EditPartner, element: renderLazyPage(<EditPartnerPage />) },
  { path: Path.AddCourse, element: renderLazyPage(<AddCoursePage />) },
  { path: Path.EditCourse, element: renderLazyPage(<EditCoursePage />) },
];
